import { get, partialRight } from 'lodash-es';

export const selectHouseRef = partialRight(get, 'house.houseRef');
export const selectHouseUserName = partialRight(get, 'house.houseUserName');
export const selectHouseID = partialRight(get, 'house.houseID');
